var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-modal", {
    attrs: {
      "modal-title": _vm.$t("pages.planing-team-validate.add_absence"),
      "show-spinner": _vm.isLoading,
      "show-modal": _vm.showModal,
      centered: true,
      "loading-primary-footer-button": _vm.isLoading,
    },
    on: _vm._d({}, [
      _vm.primaryEvent,
      _vm.onPrimaryButtonClicked,
      _vm.secondaryEvent,
      _vm.onCloseButtonClicked,
      _vm.closeEvent,
      _vm.onCloseButtonClicked,
    ]),
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "form",
              { staticClass: "permission-form add-absence-form" },
              [
                _vm.employeeInitialized
                  ? _c("div", { staticClass: "portal-employee-card" }, [
                      _c(
                        "div",
                        {
                          staticClass: "portal-employee-card__icon",
                          attrs: { "aria-hidden": "true" },
                        },
                        [_c("i", { staticClass: "fas fa-user" })]
                      ),
                      _c("div", { staticClass: "portal-employee-card__meta" }, [
                        _c(
                          "span",
                          { staticClass: "portal-employee-card__label" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "pages.planing-team-validate.employee_name"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "strong",
                          { staticClass: "portal-employee-card__name" },
                          [_vm._v(_vm._s(_vm.employee.fullName))]
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _c("suc-form-has-error", { attrs: { form: _vm.form } }),
                _c("div", { staticClass: "add-absence-section" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("absence-type-field", {
                          attrs: {
                            id: "absence-type-field",
                            name: "typeAppointment",
                            form: _vm.form,
                            required: true,
                            withoutVacation: false,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                !_vm.absenceTypeRecognized
                  ? _c("div", { staticClass: "row" }, [
                      _vm.form.typeAppointment
                        ? _c("div", { staticClass: "col" }, [
                            _c("div", { staticClass: "add-absence-alert" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "pages.permission.absences.error_absence_configuration"
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ])
                  : _c("div", { staticClass: "add-absence-section" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-12 col-md-6" },
                          [
                            _vm.absenceTypeDay
                              ? _c("absence-start-day-field", {
                                  attrs: {
                                    id: "absence-start-date",
                                    name: "dateStart",
                                    form: _vm.form,
                                    required: true,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-sm-12 col-md-6" },
                          [
                            _vm.absenceTypeDay
                              ? _c("absence-end-day-field", {
                                  attrs: {
                                    id: "absence-end-date",
                                    name: "dateEnd",
                                    form: _vm.form,
                                    required: true,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-sm-12 col-md-5" },
                          [
                            _vm.absenceTypeHour
                              ? _c("absence-day-field", {
                                  attrs: {
                                    id: "absence-end-date",
                                    name: "day",
                                    form: _vm.form,
                                    required: true,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _vm.absenceTypeHour
                        ? _c("div", { staticClass: "row" }, [
                            _vm.absenceFromWorkShift
                              ? _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _vm.$isset(_vm.workShiftHour)
                                      ? _c(
                                          "absence-hour-for-full-shift-field",
                                          {
                                            ref: "hourForFullShift",
                                            attrs: {
                                              hourTypeName: "hourType",
                                              hourStartName: "hourStart",
                                              hourEndName: "hourEnd",
                                              form: _vm.form,
                                              required: true,
                                              workShiftHour: _vm.workShiftHour,
                                            },
                                          }
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _vm.$isset(_vm.workShiftHour)
                                      ? _c("absence-hour-with-full-day-hours", {
                                          ref: "hourForFullDay",
                                          attrs: {
                                            hourTypeName: "hourType",
                                            hourStartName: "hourStart",
                                            hourEndName: "hourEnd",
                                            form: _vm.form,
                                            required: true,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("absence-file-field", {
                              attrs: {
                                id: "absence-type",
                                name: "attachment",
                                form: _vm.form,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("absence-comment-field", {
                              attrs: {
                                id: "absence-comment",
                                name: "comments",
                                form: _vm.form,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }